import type { Tenant } from "@/services/sharedTypes/tenants"
import api from "@/services/api"

type PartialUpdateTenant = Partial<{
  accessControlRestrictTransactions: boolean
  accessControlRestrictReports: boolean
  isHospitalityEnabled: boolean
  isCashEnabled: boolean
  isGratuityEnabled: boolean
  isTransactionReceiptsEnabled: boolean
  isReceiptQrCodeEnabled: boolean
  isCardReceiptsEnabled: boolean
  isAutomaticMerchantReceiptEnabled: boolean
  isProductsEnabled: boolean
  isCashiersEnabled: boolean
  isServiceChargeEnabled: boolean
  isCollectionEnabled: boolean
  defaultServiceChargePercentage: number
  defaultServiceChargeFlat: number
}>

export const partialUpdateSettings = async (
  params: Partial<PartialUpdateTenant>
) => {
  const { body } = await api.patch<Tenant>("/settings/", {
    body: params,
    version: 3,
  })
  return body
}
